import axios from "axios";
import { MatchHeight } from "js-match-height";

const selectors = {
  loadMore: "[data-load-more]",
  listingBody: ".header__mega-menu",
};

export default function init({ el, context }) {
  const nodeSelectors = {
    loadMore: document.querySelector(selectors.loadMore),
    listingBody: el,
  };

  const productHandleUrl = window.location.pathname;
  let productHandle = productHandleUrl.split("/").slice(2,productHandleUrl.length).join('/');

  const getProductsHtml = async (newPageNumber) => {
    return await axios.get(
      `/collections/${productHandle}?view=more_products&page=${newPageNumber}`
    );
  };

  const updateBody = async (newPageNumber) => {
    let html = await getProductsHtml(newPageNumber);
    if (html.data === "") {
      nodeSelectors.loadMore.innerText = "No more products";
      nodeSelectors.loadMore.disabled = true;
    } else {
      nodeSelectors.listingBody.innerHTML = nodeSelectors.listingBody.innerHTML + html.data;
      updateProductRatings()
      matchHeightsOfProdText()
    }
  };

  if(nodeSelectors.loadMore === null){
    return;
  }

  nodeSelectors.loadMore.addEventListener("click", async (event) => {
    event.preventDefault();
    let pageNumber = parseInt(el.dataset.page);
    let newPageNumber = pageNumber + 1;
    el.dataset.page = newPageNumber;
    updateBody(newPageNumber);
  });

  function updateProductRatings() {
    var api = new Yotpo.API(yotpo);
    api.refreshWidgets();
  }

  function matchHeightsOfProdText() {
    const matchHeight = new MatchHeight('.template-collection .product-block__detail__title');
    const matchHeight2 = new MatchHeight('.product-block__detail__description');
  }
}
